import script from "./SocialsModalIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialsModalIcon.vue?vue&type=script&setup=true&lang=js"

import "./SocialsModalIcon.vue?vue&type=style&index=0&id=77dc1673&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77dc1673"]])

export default __exports__